import React from "react";
import { label } from "../../../config";
import SearchInput from "./SearchInput";
import TabContent from "./TabContent";

/**
 * UsersTab component for rendering the users tab content
 * @author Muskan Thakur
 */
const UsersTab = ({ updateUserList, renderAssigneeList, containerRef, handleKeyDown }) => {
  return (
    <>
      <SearchInput
        placeholder={label.SEARCH_USERS}
        onChange={updateUserList}
        onKeyDown={handleKeyDown}
      />
      <TabContent containerRef={containerRef}>{renderAssigneeList()}</TabContent>
    </>
  );
};

export default React.memo(UsersTab);
